import { BrowserModule } from '@angular/platform-browser';
import { NgModule, isDevMode } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { TabsModule } from 'ngx-tabset';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthentificationComponent } from './components/auth/auth.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { HowToApplyComponent } from './components/common/how-to-apply/how-to-apply.component';
import { InstructorComponent } from './components/common/instructor/instructor.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { PartnerSliderComponent } from './components/common/partner-slider/partner-slider.component';
import { PartnerComponent } from './components/common/partner/partner.component';
import { PremiumAccessTwoComponent } from './components/common/premium-access-two/premium-access-two.component';
import { SloganComponent } from './components/common/slogan/slogan.component';
import { CartComponent } from './components/pages/cart/cart.component';
import { CategoriesComponent } from './components/pages/categories/categories.component';
import { CoursesStyleTwoComponent } from './components/pages/courses-style-two/courses-style-two.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { LoginComponent } from './components/pages/login/login.component';
import { MonitoringComponent } from './components/pages/monitoring/monitoring.component';
import { ProfileAuthenticationComponent } from './components/pages/profile-authentication/profile-authentication.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { ResetPasswordComponent } from './components/pages/reset-password/reset-password.component';
import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { CoursesComponent } from './components/pages/student/courses/courses.component';
import { TermsOfServiceComponent } from './components/pages/terms-of-service/terms-of-service.component';
import { UsersRegistrationModule } from './components/pages/users-registration/users-registration.module';
import { HomeComponent } from './components/pages/vendor-certification-etraining/home.component';
import { VendorAboutComponent } from './components/pages/vendor-certification-etraining/vendor-about/vendor-about.component';
import { VendorCoursesComponent } from './components/pages/vendor-certification-etraining/vendor-courses/vendor-courses.component';
import { reducers } from './store/app.states';
import { TextMaskModule } from "angular2-text-mask";
import {
  getAnalytics,
  provideAnalytics
} from '@angular/fire/analytics';

import { CountUpModule } from 'ngx-countup';
import { StickyNavModule } from 'ng2-sticky-nav';
import { LightboxModule } from 'ngx-lightbox';
import { AccordionModule } from "ngx-accordion";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FeaturesStyleFourComponent } from './components/common/features-style-four/features-style-four.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxPaginationModule } from 'ngx-pagination';
import { PdfComponent } from './components/common/pdf/pdf.component';
import { CommonComponentModule } from './components/common/common.module';
//import { FieldsetModule } from 'primeng/fieldset';
//import { TimelineModule } from 'primeng/timeline';
//import { TableModule } from 'primeng/table';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
//import { TagModule } from 'primeng/tag';
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    PartnerComponent,
    HomeComponent,
    FeaturesStyleFourComponent,
    ProfileAuthenticationComponent,
    ErrorComponent,
    TermsOfServiceComponent,
    CoursesStyleTwoComponent,
    CategoriesComponent,
    CartComponent,
    SloganComponent,
    VendorCoursesComponent,
    InstructorComponent,
    PremiumAccessTwoComponent,
    VendorAboutComponent,
    HowToApplyComponent,
    PartnerSliderComponent,
    LoginComponent,
    SignUpComponent,
    ResetPasswordComponent,
    AuthentificationComponent,
    MonitoringComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FormsModule,
    //TimelineModule,
    //TableModule,
    //TagModule,
    //ConfirmPopupModule,
    UsersRegistrationModule,
    //FieldsetModule,
    TextMaskModule,
    FontAwesomeModule,
    // NgcCookieConsentModule.forRoot(cookieConfig),
    StoreModule.forRoot(reducers),
    CommonModule,

    CommonComponentModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    HttpClientModule,

    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    provideFirestore(() => {
      const firestore = getFirestore();

      return firestore;
    }),
    CarouselModule,
    BrowserAnimationsModule,
    CountUpModule,
    StickyNavModule,
    TabsModule,
    NgxScrollTopModule,
    LightboxModule,
    NgxExtendedPdfViewerModule,
    AccordionModule,
    NgbModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }